import template from '../../templates/Home/trend.template';
import Component from '../../core/component';

export default class Trend extends Component {
  constructor(data) {
    super(template, data);
  }
}
